import React, { useContext, useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import moment from 'moment';

import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';
import { formatAddress } from 'app/src/utils/formatAssetName';
import EntityAttachments from '../Attachments/EntityAttachments';
import BankAccounts from '../BankAccounts';
import secrets from '../../../secrets';

import { VENDOR } from './queries';
import {
  VendorsContainer,
  VendorsShowContainer,
  VendorDemographicContainer,
} from './elements';
import { BankAccountsContainer } from '../../elements';

const FILE_TYPES = [
  {
    name: "W9",
    required: false,
  },
  {
    name: "Other",
    required: false
  }
];

const Vendor = () => {
  const { id } = useParams();

  const defaultFileIds = {}
  FILE_TYPES.forEach(f => defaultFileIds[f.name] = []);
  const [fileIds, setFileIds] = useState(defaultFileIds);

  const { loading, data, refetch } = useQuery(
    VENDOR, { variables: { id: id } }
  );

  useEffect(() => {
    if(data?.vendor) {

      let keys = Object.keys(fileIds);
      let newFileIds = fileIds;
      keys?.map(key => {
        newFileIds[key] = data.vendor.files?.filter(
          file => file.name === key
        );
      })
      setFileIds(newFileIds);
    }
  }, [data])

  if (loading || !data) { return <DataState.Loading />; }

  const vendor = data.vendor;

  return (
    <VendorsContainer>
      <VendorsShowContainer>
        <VendorDemographicContainer>
          <Text>{vendor.name}</Text>
          <Text>{vendor.companyName}</Text>
          <Text>{formatAddress(vendor, 'Vendor')}</Text>
          <Text>{vendor.email}</Text>
          <Text>{vendor.phoneNumber?.formatted}</Text>
        </VendorDemographicContainer>
        { secrets.app.doubleEntry &&
          <EntityAttachments
            ownerType={'Vendor'}
            ownerId={vendor?.id}
            fileTypes={FILE_TYPES}
            fileIds={fileIds}
            setFileIds={setFileIds}
          />
        }
        { secrets.app.doubleEntry &&
          <BankAccountsContainer>
            <BankAccounts ownerType='Vendor' ownerId={vendor.id} />
          </BankAccountsContainer>
        }
      </VendorsShowContainer>
    </VendorsContainer>
  );
};

export default Vendor;
